var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClearDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3627_52773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.875 0H10.125C4.545 0 0 4.545 0 10.125V43.875C0 49.455 4.545 54 10.125 54H43.875C49.455 54 54 49.455 54 43.875V10.125C54 4.545 49.455 0 43.875 0ZM51.75 43.875C51.75 48.2175 48.2175 51.75 43.875 51.75H10.125C5.7825 51.75 2.25 48.2175 2.25 43.875V10.125C2.25 5.7825 5.7825 2.25 10.125 2.25H43.875C48.2175 2.25 51.75 5.7825 51.75 10.125V43.875ZM11.25 21.375C11.25 20.745 11.745 20.25 12.375 20.25H34.875C35.505 20.25 36 20.745 36 21.375C36 22.005 35.505 22.5 34.875 22.5H12.375C11.745 22.5 11.25 22.005 11.25 21.375ZM11.25 12.375C11.25 11.745 11.745 11.25 12.375 11.25H28.125C28.755 11.25 29.25 11.745 29.25 12.375C29.25 13.005 28.755 13.5 28.125 13.5H12.375C11.745 13.5 11.25 13.005 11.25 12.375ZM42.75 30.375C42.75 31.005 42.255 31.5 41.625 31.5H12.375C11.745 31.5 11.25 31.005 11.25 30.375C11.25 29.745 11.745 29.25 12.375 29.25H41.625C42.255 29.25 42.75 29.745 42.75 30.375ZM20.25 39.375C20.25 40.005 19.755 40.5 19.125 40.5H12.375C11.745 40.5 11.25 40.005 11.25 39.375C11.25 38.745 11.745 38.25 12.375 38.25H19.125C19.755 38.25 20.25 38.745 20.25 39.375Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3627_52773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearDoc);
export default __webpack_public_path__ + "static/media/clear-doc.844f1765614cc4036312c4505f321938.svg";
export { ForwardRef as ReactComponent };